/* eslint-disable */

// For Pages Router (pages directory)
import { useRouter as usePagesRouter } from 'next/router';
// For App Router (app directory)
import { usePathname, useSearchParams } from 'next/navigation';

// Use this in Pages Router components
export function useFullPathPagesRouter(): string {
  const router = usePagesRouter();
  return router.asPath;
}

// Use this in App Router components
export function useFullPathAppRouter(): string {
  const pathname = usePathname();
  const searchParams = useSearchParams();
  let hash = '';
  if (typeof window !== 'undefined' && window.location.hash) {
    hash = window.location.hash;
  }
  return `${pathname}${searchParams?.toString() ? `?${searchParams}` : ''}${hash}`;
}

export function useFullPath(): string {
  // Always use window.location for the most accurate URL including hash
  // This ensures we capture query params and hash fragments that might be missed by router
  if (typeof window !== 'undefined') {
    const pathname = window.location.pathname;
    const search = window.location.search;
    const hash = window.location.hash;
    const fullPath = `${pathname}${search}${hash}`;
    return fullPath;
  }

  // Fallback for SSR (though this shouldn't be used for auth redirects)
  try {
    const router = usePagesRouter();
    if (router && router.asPath) {
      return router.asPath;
    }
  } catch {
    // Pages Router fallback failed
    return '';
  }

  return '';
}
